import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { AuthService } from '../auth/auth.service';
import { AlarmasService } from 'src/app/services/eventos/alarmas.service';
import { Globals } from '../global/global';
import { UsuarioService } from '../usuario/usuario.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router,
    private authService: AuthService,
    private alarmasService: AlarmasService,
    public globals: Globals,
    public usuarioService: UsuarioService
  ) {
  }

  canActivate() {
    // console.log('actualizando ...f5');

    if (this.authService.logueado()) {
      // this.alarmasService.socketConnect();
      // this.usuarioService.getUsuarioMac().subscribe(mac => {
      //   this.alarmasService.sendUsuarioMac(mac);
      // });
      // this.globals.cont_evento;
      // console.log(this.globals.cont_evento);
      return true;
    } else {
      // console.log('Bloqueado por el Guard');
      this.router.navigate(['/login']);
      this.authService.logout();
      return false;
    }

  }
}
